import React, { useMemo } from "react";

import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import { ButtonContainer, Button } from "shared/components";
import { Icon } from "shared/styles";
import { IInfoBlockItem, ITheme } from "shared/types";

const { infoBlockProperties } = copy;

interface IAddButton {
  key: string;
  label: string;
  onClick: () => void;
}

interface InfoBlockAddButtonsProps {
  openChooseModal: (type: IInfoBlockItem) => void;
  openAddModal: (type: IInfoBlockItem) => void;
}

export const InfoBlockAddButtons: React.FC<InfoBlockAddButtonsProps> = ({
  openChooseModal,
  openAddModal,
}) => {
  const addButtons: IAddButton[] = useMemo(
    () => [
      {
        key: IInfoBlockItem.place,
        label: infoBlockProperties.place.title,
        onClick: () => openChooseModal(IInfoBlockItem.place),
        "data-testid": `add_${IInfoBlockItem.place}`,
      },
      {
        key: IInfoBlockItem.contact,
        label: infoBlockProperties.contact.title,
        onClick: () => openChooseModal(IInfoBlockItem.contact),
        "data-testid": `add_${IInfoBlockItem.contact}`,
      },
      {
        key: IInfoBlockItem.file,
        label: infoBlockProperties.file.title,
        onClick: () => openAddModal(IInfoBlockItem.file),
        "data-testid": `add_${IInfoBlockItem.file}`,
      },
      {
        key: IInfoBlockItem.image,
        label: infoBlockProperties.image.title,
        onClick: () => openAddModal(IInfoBlockItem.image),
        "data-testid": `add_${IInfoBlockItem.image}`,
      },
    ],
    [openChooseModal, openAddModal]
  );

  const renderAddButton = ({ label, ...rest }: IAddButton) => (
    <Button theme={ITheme.secondary} {...rest}>
      <Icon as={Plus} />
      <span>{label}</span>
    </Button>
  );

  return <ButtonContainer>{addButtons.map(renderAddButton)}</ButtonContainer>;
};
